export { Img, ImgSrcPropType } from './Img';
